import { render, staticRenderFns } from "./AllAdministrationSubmissions.vue?vue&type=template&id=3645c227&scoped=true&"
import script from "./AllAdministrationSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllAdministrationSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllAdministrationSubmissions.vue?vue&type=style&index=0&id=3645c227&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3645c227",
  null
  
)

export default component.exports